{
  "language.label": "Langue",
  "language.english": "Anglais",
  "language.english.full": "Anglais (English)",
  "language.french": "Français",
  "language.french.full": "Français (Français)",
  "language.dutch": "Néerlandais",
  "language.dutch.full": "Néerlandais (Nederlands)",
  "logo.alt": "Logo Flourish",
  "brand.tagline": "Région Champagne",
  "brand.taglineFooter": "Région Champagne",
  "nav.tourism": "Tourisme",
  "nav.route": "Route touristique",
  "nav.community": "Communauté",
  "nav.wineries": "Maisons de champagne",
  "nav.download": "Télécharger",
  "nav.partner": "Devenir partenaire",
  "nav.downloadCta": "Télécharger l'app",
  "partnerModal.eyebrow": "Inscription partenaire",
  "partnerModal.title": "Êtes-vous une maison de champagne ?",
  "partnerModal.body": "Ce portail est réservé aux maisons de champagne qui souhaitent s'inscrire et apparaître dans Flourish. Merci de confirmer avant de continuer.",
  "partnerModal.confirm": "Oui, continuer l'inscription",
  "partnerModal.cancel": "Non, je veux découvrir",
  "partnerModal.close": "Fermer la fenêtre",
  "hero.eyebrow": "L'application parfaite pour découvrir champagne",
  "hero.title": "Découvrez la Champagne avec Flourish.",
  "hero.body": "Flourish est votre compagnon élégant tandis que vous traversez la Champagne. Suivez la Route Touristique, découvrez de nouveaux lieux et transformez chaque arrêt en récit vivant avec les avis locaux et les expériences de vos amis.",
  "hero.highlight.reviews.title": "Avis par lieu",
  "hero.highlight.reviews.body": "Notes de dégustation, ambiance et conseils d'initiés à chaque étape.",
  "hero.highlight.friends.title": "Suivez vos amis",
  "hero.highlight.friends.body": "Consultez leurs itinéraires, leurs favoris et les avis qu'ils ont partagés.",
  "hero.appStoreAlt": "Télécharger sur l'App Store",
  "hero.playStoreAlt": "Disponible sur Google Play",
  "home.dashboard.hero.eyebrow": "Flourish sur le web",
  "home.dashboard.hero.title": "Planifiez, découvrez et vivez la Champagne.",
  "home.dashboard.hero.body": "Parcourez les maisons de champagne et leur sélection de cuvées, découvrez des lieux comme les musées, sites historiques, points de vue et attractions, et suivez les boucles officielles de la Route Touristique pour préparer votre prochaine visite depuis un seul endroit.",
  "home.dashboard.hero.primaryCta": "Ouvrir la carte web",
  "home.dashboard.hero.secondaryCta": "Télécharger l'app mobile",
  "home.dashboard.hero.loginCta": "Se connecter pour synchroniser",
  "home.dashboard.hero.stepsTitle": "Les 3 avantages de la plateforme",
  "home.dashboard.hero.steps.one.title": "Rencontrez les maisons de Champagne",
  "home.dashboard.hero.steps.one.body": "Découvrez leur histoire, leurs méthodes et leurs cuvées signatures.",
  "home.dashboard.hero.steps.two.title": "Un large choix de lieux",
  "home.dashboard.hero.steps.two.body": "Musées, points de vue, sites et plus encore.",
  "home.dashboard.hero.steps.three.title": "Des retours d'expérience",
  "home.dashboard.hero.steps.three.body": "Lisez ce que d'autres visiteurs ont aimé.",
  "home.dashboard.overview.eyebrow": "Vue d'ensemble",
  "home.dashboard.overview.title": "Votre tableau de bord Champagne",
  "home.dashboard.stats.comingSoon": "Bientôt disponible",
  "home.dashboard.stats.loginRequired": "Connectez-vous pour synchroniser",
  "home.dashboard.explore.eyebrow": "Découvrir maintenant",
  "home.dashboard.explore.title": "Sélection du moment en Champagne",
  "home.dashboard.explore.body": "Un mélange renouvelé de maisons de champagne et de lieux pour inspirer votre prochaine halte.",
  "home.dashboard.explore.openMap": "Découvrir plus de lieux",
  "home.dashboard.explore.empty": "Nous préparons cette sélection. Revenez bientôt.",
  "home.dashboard.routes.title": "Routes touristiques",
  "home.dashboard.routes.body": "Six boucles officielles de la Route Touristique sont disponibles sur la carte web.",
  "home.dashboard.activity.title": "Activité de la communauté",
  "home.dashboard.activity.body": "Consultez les dernières dégustations et visites de votre réseau.",
  "home.dashboard.activity.empty": "Aucune activité récente à afficher.",
  "home.dashboard.activity.more": "Ouvrir l'activité",
  "home.dashboard.activity.loginTitle": "Connectez-vous pour voir l'activité",
  "home.dashboard.activity.loginBody": "Connectez-vous pour voir les dégustations et visites de vous et vos amis.",
  "home.dashboard.activity.loginCta": "Aller à la connexion",
  "home.dashboard.mobile.eyebrow": "Compagnon mobile",
  "home.dashboard.mobile.title": "Emportez Flourish sur la route",
  "home.dashboard.mobile.body": "Utilisez le web pour préparer, puis continuez dans l'app pendant votre voyage en Champagne.",
  "route.eyebrow": "Route touristique",
  "route.title": "Planifiez une journée sur mesure, sans la foule.",
  "route.body": "Flourish relie villages, points de vue et dégustations en un itinéraire fluide. Suivez la route classique ou tracez votre propre parcours autour de vos lieux préférés.",
  "route.cards.one.title": "Commencez par un itinéraire signature",
  "route.cards.one.body": "Choisissez une Route Touristique prête à l'emploi ou créez votre propre planning autour de vos lieux préférés.",
  "route.cards.two.title": "Découvrez des trésors cachés",
  "route.cards.two.body": "Découvrez de nouveaux points de vue, attractions et adresses locales.",
  "route.cards.three.title": "Partagez la journée",
  "route.cards.three.body": "Invitez vos amis, comparez vos notes et enregistrez les étapes préférées de chacun.",
  "community.eyebrow": "Avis de la communauté",
  "community.title": "Chaque halte a une histoire à raconter.",
  "community.body": "Les avis vous montrent à quoi vous attendre sur place. Suivez vos amis pour découvrir leurs lieux préférés et leurs recommandations.",
  "community.reviews.one.name": "Camille R.",
  "community.reviews.one.body": "\"Arrivés juste avant le coucher du soleil. Dégustation intimiste et vol de rosé inoubliable.\"",
  "community.reviews.one.location": "Verzenay - Arrêt Grand Cru",
  "community.reviews.two.name": "Lucas M.",
  "community.reviews.two.body": "\"La visite des caves était riche en détails. J'ai adoré les accords partagés par les locaux dans l'app.\"",
  "community.reviews.two.location": "Hautvillers - Allée patrimoniale",
  "community.reviews.three.name": "Jules + Nora",
  "community.reviews.three.body": "\"On a suivi la boucle de nos amis, ajouté un pique-nique et terminé à l'heure de l'apéritif.\"",
  "community.reviews.three.location": "Côte des Blancs",
  "wineries.tag": "Disponible bientôt",
  "wineries.title": "Découvrez des maisons de champagne d'exception",
  "wineries.body": "Nous sélectionnons soigneusement des maisons de champagne avec dégustations et vins uniques, pour vous.",
  "wineries.cards.one.title": "Contactez la maison",
  "wineries.cards.one.body": "Contactez directement la maison pour vous renseigner sur les visites, les disponibilités et les expériences.",
  "wineries.cards.two.title": "Signatures de maison",
  "wineries.cards.two.body": "Découvrez des cuvées d'exception et l'histoire de chaque cave.",
  "wineries.cards.three.title": "Sélections de collection",
  "wineries.cards.three.body": "Suivez vos bouteilles préférées dans l'app et partagez vos expériences avec vos amis.",
  "download.eyebrow": "Disponible maintenant",
  "download.title": "Téléchargez Flourish et commencez votre tour de Champagne.",
  "download.body": "Trouvez l'app sur l'App Store ou Google Play et commencez à collecter itinéraires, avis et recommandations.",
  "download.qrLabel": "Scannez pour télécharger l'app.",
  "download.qrAlt": "QR code pour télécharger l'app Flourish",
  "download.modal.close": "Fermer la fenêtre",
  "appPromo.eyebrow": "App mobile optimisée",
  "appPromo.title": "Téléchargez l'app Flourish",
  "appPromo.body": "Cette expérience se vit dans l'app. Téléchargez-la pour explorer la carte, enregistrer des favoris et suivre l'activité.",
  "appPromo.homeLink": "Continuer vers le site",
  "web.nav.home": "Accueil",
  "web.nav.map": "Carte",
  "web.nav.houses": "Maisons de champagne",
  "web.nav.experiences": "Expériences",
  "web.nav.guides": "Guides",
  "web.map.locate": "Centrer sur ma position",
  "web.map.eyebrow": "Carte interactive",
  "web.map.title": "Explorez la Champagne sur le web",
  "web.map.subtitle": "Parcourez les maisons de champagne, lieux et routes touristiques sur une carte pensée pour le bureau.",
  "web.map.empty": "Aucun lieu à afficher pour le moment. Ajustez vos filtres pour en voir davantage.",
  "web.map.save": "Enregistrer",
  "web.map.saved": "Enregistré",
  "web.map.list": "Liste",
  "web.favorites.subtitle": "Vos maisons de champagne et lieux enregistrés, prêts pour votre prochaine visite.",
  "web.activity.subtitle": "Suivez les dégustations et visites partagées par la communauté.",
  "web.activity.loadMore": "Charger plus",
  "web.activity.loadingMore": "Chargement…",
  "web.profile.subtitle": "Connectez-vous ou créez un compte pour synchroniser vos favoris.",
  "web.profile.verified": "Email vérifié",
  "web.profile.unverified": "Email non vérifié",
  "web.profile.verify.title": "Vérifiez votre e-mail",
  "web.profile.verify.body": "Saisissez le code à 6 chiffres envoyé à {{ email }}.",
  "web.profile.verify.label": "Code de vérification",
  "web.profile.verify.placeholder": "Code à 6 chiffres",
  "web.profile.verify.send": "Renvoyer le code",
  "web.profile.verify.sending": "Renvoi…",
  "web.profile.verify.submit": "Vérifier l’e-mail",
  "web.profile.verify.verifying": "Vérification…",
  "web.profile.verify.validation": "Saisissez le code à 6 chiffres.",
  "web.profile.verify.sent": "Code de vérification envoyé.",
  "web.profile.verify.success": "E-mail vérifié. Merci !",
  "web.profile.verify.error": "Impossible de vérifier votre e-mail. Réessayez.",
  "web.profile.verify.sendError": "Impossible d’envoyer le code de vérification. Réessayez.",
  "web.profile.session.title": "Session",
  "web.profile.session.body": "Déconnectez-vous pour changer de compte ou réinitialiser votre session.",
  "web.profile.loading": "Chargement…",
  "web.profile.account.edit": "Modifier",
  "web.profile.account.close": "Fermer",
  "web.profile.accountOptions.title": "Options du compte",
  "web.profile.accountOptions.description": "Supprimez votre compte.",
  "seo.site.name": "Flourish",
  "seo.home.title": "Découvrez la Champagne avec Flourish",
  "seo.home.description": "Organisez une escapade en Champagne avec des routes soigneusement sélectionnées, des maisons emblématiques et des étapes incontournables.",
  "seo.map.title": "Carte et itinéraires de Champagne",
  "seo.map.description": "Explorez maisons de champagne, lieux et routes touristiques sur une carte interactive pensée pour préparer votre visite.",
  "seo.houses.title": "Maisons de Champagne",
  "seo.houses.description": "Parcourez les maisons de Champagne vérifiées sur Flourish, découvrez la maison mise à l'honneur du jour et explorez vins, visites et histoires de la région.",
  "seo.getApp.title": "Télécharger l'app Flourish",
  "seo.getApp.description": "Téléchargez Flourish pour enregistrer vos favoris, suivre la Route Touristique et garder votre guide en poche.",
  "seo.experiences.title": "Expériences en Champagne",
  "seo.experiences.description": "Parcourez les expériences vérifiées proposées par les maisons partenaires et préparez votre prochaine dégustation ou visite en Champagne.",
  "seo.guides.title": "Guides de voyage en Champagne",
  "seo.guides.description": "Préparez maisons, dégustations, villages, itinéraires, routes et premières expériences en Champagne avec les guides Flourish.",
  "seo.favorites.title": "Vos favoris en Champagne",
  "seo.favorites.description": "Conservez une sélection de maisons de champagne et de lieux pour votre prochain séjour.",
  "seo.activity.title": "Dégustations & visites",
  "seo.activity.description": "Suivez les dégustations et visites partagées par la communauté Flourish.",
  "seo.profile.title": "Votre profil Flourish",
  "seo.profile.description": "Gérez votre compte, synchronisez vos favoris et vérifiez votre e-mail.",
  "seo.winery.description": "Découvrez {{ name }} en Champagne. Infos de dégustation, contacts et itinéraire.",
  "seo.wine.description": "Découvrez {{ wine }} de {{ winery }} et préparez votre dégustation.",
  "seo.landmark.description": "Découvrez {{ name }} en Champagne et préparez votre visite avec Flourish.",
  "tabs.map": "Carte",
  "tabs.nearby": "À proximité",
  "tabs.favorites": "Favoris",
  "tabs.activity": "Activité",
  "tabs.profile": "Profil",
  "activity.title": "Activité",
  "activity.loading": "Chargement de l'activité…",
  "activity.empty.title": "Aucune activité pour le moment",
  "activity.empty.description": "Les dégustations de vos amis et les vôtres apparaîtront ici.",
  "activity.items.tasting": "Dégustation",
  "activity.items.wineryVisit": "Visite de maison de champagne",
  "activity.items.landmarkVisit": "Visite de lieu",
  "activity.errors.load": "Impossible de charger l'activité pour le moment.",
  "activity.loginPrompt.title": "Connectez-vous pour voir l'activité",
  "activity.loginPrompt.description": "Connectez-vous pour voir les dégustations de vos amis et les vôtres.",
  "activity.loginPrompt.button": "Aller à la connexion",
  "nearby.title": "À proximité",
  "nearby.loading": "Recherche des lieux autour de vous...",
  "nearby.empty.title": "Aucun lieu à afficher",
  "nearby.empty.description": "Activez la localisation pour voir les maisons de champagne et les lieux d'intérêt proches.",
  "nearby.distance": "{{ distance }} km",
  "nearby.locationFallback": "Impossible d'accéder à votre position. Les distances sont calculées depuis la région de Champagne.",
  "nearby.errors.load": "Impossible de charger les lieux à proximité.",
  "nearby.filter.title": "Filtrer par catégorie",
  "nearby.filter.all": "Tous",
  "nearby.filter.wineries": "Maisons de champagne",
  "nearby.filter.showFavorites": "Afficher uniquement les favoris",
  "nearby.filter.categories": "Catégories",
  "nearby.filter.filter": "Filtrer",
  "nearby.sort.label": "Trier",
  "nearby.sort.distance": "Distance",
  "nearby.sort.alpha": "Alphabétique",
  "nearby.filter.reset": "Réinitialiser",
  "nearby.filter.apply": "Appliquer",
  "map.title": "Carte",
  "map.marker.youAreHere": "Vous êtes ici",
  "map.marker.showMore": "Voir plus",
  "map.marker.openPage": "Ouvrir la page",
  "map.marker.wineryLabel": "Maisons de champagne",
  "map.list.comingSoon.title": "Bientôt disponible",
  "map.list.comingSoon.body": "Nous travaillons sur les maisons de champagne et le lancement arrive dans quelques semaines.",
  "map.marker.routeLabel": "Route touristique",
  "map.marker.routeDownloadCta": "Téléchargez l'app pour suivre cette route",
  "map.marker.toggleFavorite": "Ajouter/retirer des favoris",
  "map.detail.loading": "Chargement des détails...",
  "map.detail.error": "Impossible de charger les détails.",
  "map.detail.close": "Fermer",
  "map.detail.backToMap": "Retour à la carte",
  "map.detail.wineryLabel": "Maison de champagne",
  "map.detail.verifiedProfile": "Maison vérifiée",
  "map.detail.wineLabel": "Champagne",
  "map.detail.wine.from": "Maison de champagne",
  "map.detail.wine.backToWinery": "Retour à la maison",
  "map.detail.wine.specs": "Détails techniques",
  "map.detail.wine.dosage": "Dosage",
  "map.detail.wine.assemblage": "Assemblage",
  "map.detail.section.houseHistory": "Histoire de la maison",
  "map.detail.section.tastingExperience": "Expérience de dégustation",
  "map.detail.section.description": "Description",
  "map.detail.section.experiences": "Expériences",
  "experiences.page.eyebrow": "Expériences vérifiées",
  "houses.page.eyebrow": "Maisons de Champagne",
  "houses.page.title": "Découvrez les maisons qui peuvent rythmer votre prochaine escapade en Champagne.",
  "houses.page.body": "Parcourez une collection grandissante de maisons de Champagne sur Flourish, entre signatures reconnues et adresses plus confidentielles à intégrer à votre itinéraire.",
  "houses.page.signals.curated.title": "Pensé pour la découverte",
  "houses.page.signals.curated.body": "Chaque profil est présenté comme une destination à part entière, pas comme une simple fiche dans un annuaire.",
  "houses.page.signals.verified.title": "Profils vérifiés",
  "houses.page.signals.verified.body": "Les maisons affichées ici sont publiques, vérifiées et prêtes à être explorées sur Flourish.",
  "houses.page.signals.planning.title": "Utile pour planifier",
  "houses.page.signals.planning.body": "Passez facilement de l'inspiration à une page maison, une vue carte ou une idée de dégustation sans quitter la plateforme.",
  "houses.page.featured.eyebrow": "Maison du jour",
  "houses.page.actions.open": "Ouvrir",
  "houses.page.actions.viewHouse": "Voir la maison",
  "houses.page.actions.openMap": "Ouvrir sur la carte",
  "houses.page.filters.search": "Recherche",
  "houses.page.filters.searchPlaceholder": "Rechercher par nom de maison",
  "houses.page.filters.city": "Ville",
  "houses.page.filters.allCities": "Toutes les villes",
  "houses.page.filters.hasExperiences": "Avec expériences",
  "houses.page.filters.hasWines": "Avec vins",
  "houses.page.filters.favorites": "Favoris uniquement",
  "houses.page.filters.sort": "Trier",
  "houses.page.filters.clear": "Réinitialiser les filtres",
  "houses.page.sort.alphabetical": "A à Z",
  "houses.page.sort.recent": "Mises à jour récentes",
  "houses.page.collection.eyebrow": "Poursuivre l'exploration",
  "houses.page.collection.title": "Des maisons de Champagne à découvrir",
  "houses.page.card.fallback": "Ouvrez la page complète de la maison pour découvrir son histoire, ses vins et ses informations de visite.",
  "houses.page.meta.experience.one": "{{ count }} expérience",
  "houses.page.meta.experience.other": "{{ count }} expériences",
  "houses.page.meta.experience.from.one": "{{ count }} expérience dès {{ price }}",
  "houses.page.meta.experience.from.other": "{{ count }} expériences dès {{ price }}",
  "houses.page.meta.wine.one": "{{ count }} cuvée",
  "houses.page.meta.wine.other": "{{ count }} cuvées",
  "houses.page.empty.eyebrow": "Aucun résultat précis",
  "houses.page.empty.title": "Aucune maison ne correspond à ces filtres pour le moment",
  "houses.page.empty.body": "Réinitialisez les filtres ou revenez à la carte pour poursuivre votre découverte de la Champagne autrement.",
  "houses.page.empty.cta": "Explorer la carte",
  "houses.page.footer.eyebrow": "Continuer la découverte",
  "houses.page.footer.title": "Changez de point de vue quand vous voulez.",
  "houses.page.footer.body": "Utilisez la carte pour explorer la région géographiquement ou ouvrez les expériences pour vous concentrer sur les dégustations et visites déjà disponibles.",
  "houses.page.footer.mapCta": "Ouvrir la carte",
  "houses.page.footer.experiencesCta": "Voir les expériences",
  "experiences.page.title": "Réservez les expériences les plus marquantes de Champagne.",
  "experiences.page.body": "Une sélection évolutive de dégustations, visites de cave et moments proposés par des maisons de Champagne vérifiées, réunis au même endroit.",
  "experiences.page.stats.experiences": "Expériences",
  "experiences.page.stats.houses": "Maisons de Champagne",
  "experiences.page.highlights.curated.title": "Sélectionnées avec soin",
  "experiences.page.highlights.curated.body": "Chaque expérience provient d’une maison de Champagne vérifiée déjà présente sur Flourish.",
  "experiences.page.highlights.booking.title": "Pensé pour planifier",
  "experiences.page.highlights.booking.body": "Consultez le prix, la durée et la maison qui organise l’expérience avant de réserver.",
  "experiences.page.highlights.local.title": "Encore plus bientôt",
  "experiences.page.highlights.local.body": "Le catalogue démarre à peine, donc chaque nouvelle expérience profite d’une vraie mise en valeur.",
  "experiences.page.collection.eyebrow": "Encore à découvrir",
  "experiences.page.collection.title": "Poursuivre l’exploration",
  "experiences.page.singleNote": "D’autres expériences vérifiées apparaîtront ici à mesure que de nouvelles maisons publieront leurs offres.",
  "experiences.page.empty.title": "Les expériences arrivent bientôt",
  "experiences.page.empty.body": "Nos maisons partenaires préparent leurs premières expériences publiques. Revenez bientôt ou explorez la carte de Champagne en attendant.",
  "experiences.page.empty.cta": "Explorer la carte",
  "map.detail.section.contact": "Contact",
  "map.detail.section.wines": "Vins signature",
  "map.detail.field.address": "Adresse",
  "map.detail.field.email": "E-mail",
  "map.detail.field.website": "Site web",
  "map.detail.field.phone": "Téléphone",
  "map.detail.action.openWebsite": "Ouvrir",
  "map.detail.action.call": "Appeler",
  "map.detail.action.email": "E-mail",
  "map.detail.action.navigate": "Itinéraire",
  "map.detail.action.appleMaps": "Apple Plans",
  "map.detail.action.googleMaps": "Google Maps",
  "map.detail.wines.empty": "Aucun vin disponible pour le moment.",
  "map.detail.wines.noDescription": "Pas encore de description.",
  "map.detail.experiences.noDescription": "Plus de détails arrivent bientôt.",
  "map.detail.experiences.checkAvailability": "Voir les disponibilités",
  "map.detail.experiences.availableNow": "Disponible maintenant",
  "map.detail.experiences.from": "À partir de",
  "experience.detail.availability.loading": "Chargement des disponibilités...",
  "experience.detail.availability.loadError": "Impossible de charger les disponibilités pour le moment.",
  "experience.detail.duration": "Durée",
  "experience.detail.gallery.open": "Cliquer pour agrandir",
  "experience.detail.gallery.modal": "Galerie d'images de l'expérience",
  "experience.detail.gallery.close": "Fermer la galerie d'images",
  "experience.detail.gallery.previous": "Image précédente",
  "experience.detail.gallery.next": "Image suivante",
  "experience.detail.gallery.thumbnail": "Ouvrir l'image {{index}}",
  "experience.detail.gallery.counter": "Image {{current}} sur {{total}}",
  "experience.detail.section.practicalInfo": "Infos pratiques",
  "experience.detail.section.includedExcluded": "Inclus et exclus",
  "experience.detail.section.location": "Lieu",
  "experience.detail.section.price": "Prix",
  "experience.detail.practicalInfo.knowBeforeYouGo": "À savoir avant de partir",
  "experience.detail.practicalInfo.requirements": "Exigences",
  "experience.detail.practicalInfo.location": "Lieu",
  "experience.detail.includedExcluded.included": "Inclus",
  "experience.detail.includedExcluded.excluded": "Exclus",
  "experience.detail.price.adult": "Adulte",
  "experience.detail.price.child": "Enfant",
  "experience.detail.availability.timeslots": "Créneaux disponibles",
  "experience.detail.availability.noFutureAvailabilityTitle": "Aucun créneau disponible",
  "experience.detail.availability.book": "Réserver",
  "experience.detail.availability.noSlots": "Sélectionnez une date disponible pour voir les créneaux proposés.",
  "experience.detail.availability.noFutureAvailability": "Aucune prochaine date n'est disponible pour cette expérience pour le moment.",
  "experience.detail.availability.unlimited": "Billets disponibles",
  "experience.detail.availability.ticketsLeft": "{{count}} billets restants",
  "experience.booking.modal.close": "Fermer la fenêtre de réservation",
  "experience.booking.step.selection": "Sélection",
  "experience.booking.step.details": "Coordonnées",
  "experience.booking.step.payment": "Paiement",
  "experience.booking.step.confirmation": "Confirmation",
  "experience.booking.stepCounter": "Étape {{current}} sur {{total}}",
  "experience.booking.summary.date": "Date",
  "experience.booking.summary.startHour": "Heure de début",
  "experience.booking.summary.endHour": "Heure de fin",
  "experience.booking.summary.from": "De",
  "experience.booking.summary.until": "à",
  "experience.booking.summary.price": "Prix",
  "experience.booking.summary.guestSingular": "participant",
  "experience.booking.summary.guestPlural": "participants",
  "experience.booking.selection.title": "Choisissez vos participants",
  "experience.booking.selection.subtitle": "Sélectionnez le nombre d'adultes et d'enfants pour cette expérience.",
  "experience.booking.selection.total": "Prix total",
  "experience.booking.selection.decreaseAdult": "Réduire le nombre d'adultes",
  "experience.booking.selection.increaseAdult": "Augmenter le nombre d'adultes",
  "experience.booking.selection.decreaseChild": "Réduire le nombre d'enfants",
  "experience.booking.selection.increaseChild": "Augmenter le nombre d'enfants",
  "experience.booking.details.title": "Renseignez vos coordonnées",
  "experience.booking.details.subtitle": "Saisissez les coordonnées de contact pour cette réservation.",
  "experience.booking.details.firstName": "Prénom",
  "experience.booking.details.lastName": "Nom",
  "experience.booking.details.email": "Adresse e-mail",
  "experience.booking.details.phone": "Numéro de téléphone",
  "experience.booking.details.error": "Veuillez remplir tous les champs et saisir une adresse e-mail valide.",
  "experience.booking.payment.title": "Paiement",
  "experience.booking.payment.subtitle": "Payez en toute sécurité pour finaliser cette réservation.",
  "experience.booking.payment.loading": "Préparation du paiement sécurisé...",
  "experience.booking.payment.fallback": "Ou continuez avec une carte ou Bancontact",
  "experience.booking.payment.note": "Selon le mode de paiement, vous pouvez être brièvement redirigé pour autoriser le paiement. Une fois le paiement réussi, nous finaliserons la réservation et enverrons votre e-mail de confirmation.",
  "experience.booking.payment.error": "Nous n'avons pas pu finaliser votre réservation. Veuillez réessayer.",
  "experience.booking.payment.returnError": "Nous n'avons pas pu confirmer votre paiement après votre retour. Veuillez réessayer.",
  "experience.booking.confirmation.subtitle": "Consultez la confirmation de réservation.",
  "experience.booking.confirmation.title": "Confirmation de réservation",
  "experience.booking.confirmation.message": "Votre réservation a bien été effectuée. Un e-mail de confirmation vous sera envoyé bientôt.",
  "experience.booking.closeConfirm.title": "Fermer la réservation ?",
  "experience.booking.closeConfirm.message": "Voulez-vous vraiment fermer ce parcours de réservation ? Votre progression actuelle sera perdue.",
  "experience.booking.closeConfirm.confirm": "Fermer la réservation",
  "experience.booking.closeConfirm.cancel": "Poursuivre la réservation",
  "experience.booking.actions.back": "Retour",
  "experience.booking.actions.next": "Suivant",
  "experience.booking.actions.confirm": "Confirmer la réservation",
  "experience.booking.actions.pay": "Payer maintenant",
  "experience.booking.actions.processing": "Traitement...",
  "experience.booking.actions.close": "Fermer",
  "map.detail.wines.unshared": "Cette maison de champagne ne partage pas encore ses champagnes avec nous.",
  "map.detail.wines.grapes": "cépages",
  "map.legend.title": "Légende",
  "map.legend.landmarksTitle": "Lieux",
  "map.loading.google": "Chargement de la carte…",
  "map.loading.wineries": "Chargement des maisons de champagne…",
  "map.loading.places": "Chargement des lieux…",
  "map.touristicRoutes.title": "Routes touristiques",
  "map.touristicRoutes.names.montagneDeReims": "Montagne de Reims",
  "map.touristicRoutes.names.valleeDeLaMarne": "Vallée de la Marne",
  "map.touristicRoutes.names.coteDesBlancs": "Côte des Blancs",
  "map.touristicRoutes.names.coteauxVitryats": "Coteaux Vitryats",
  "map.touristicRoutes.names.coteauxSezannais": "Coteaux Sézannais",
  "map.touristicRoutes.names.coteDesBar": "Côte des Bar",
  "map.touristicRoutes.background.montagneDeReims": "Une boucle au cœur de la Montagne de Reims, entre forêts et villages emblématiques du Champagne.",
  "map.touristicRoutes.background.valleeDeLaMarne": "Suivez la Vallée de la Marne, où les vignes longent la rivière au fil de villages de caractère.",
  "map.touristicRoutes.background.coteDesBlancs": "Découvrez les coteaux crayeux de la Côte des Blancs, berceau du Chardonnay en Champagne.",
  "map.touristicRoutes.background.coteauxVitryats": "Un itinéraire plus confidentiel autour des Coteaux Vitryats, entre paysages ouverts et vignobles discrets.",
  "map.touristicRoutes.background.coteauxSezannais": "Parcourez les Coteaux Sézannais, un relief vallonné mêlant vignes et villages champêtres.",
  "map.touristicRoutes.background.coteDesBar": "Cap au sud vers la Côte des Bar, réputée pour ses Pinot Noir et ses grands paysages ruraux.",
  "map.errors.googleLoad": "Impossible de charger la carte pour le moment. Veuillez réessayer plus tard.",
  "map.errors.wineries": "Impossible de charger la liste des maisons de champagne.",
  "map.errors.landmarks": "Impossible de charger les lieux.",
  "map.errors.routes": "Impossible de charger les routes touristiques.",
  "map.controls.location": "Centrer sur ma position",
  "favorites.errors.loginRequired": "Veuillez vous connecter pour gérer vos favoris.",
  "favorites.errors.update": "Impossible de mettre à jour les favoris pour le moment.",
  "favorites.title": "Favoris",
  "favorites.empty.title": "Aucun favori",
  "favorites.empty.description": "Touchez l'icône en forme de cœur pour enregistrer une maison de champagne ou un lieu ici.",
  "favorites.empty.wineriesTitle": "Aucune maison de champagne",
  "favorites.empty.wineriesDescription": "Explorez la carte et appuyez sur le cœur pour ajouter une maison de champagne.",
  "favorites.empty.landmarksTitle": "Aucun lieu enregistré",
  "favorites.empty.landmarksDescription": "Ajoutez des lieux à vos favoris pour les retrouver facilement.",
  "favorites.loginPrompt.title": "Connectez-vous pour enregistrer des favoris",
  "favorites.loginPrompt.description": "Créez un compte pour suivre vos maisons de champagne préférées.",
  "favorites.loginPrompt.button": "Aller à la connexion",
  "favorites.list.add": "Ajouter aux favoris",
  "favorites.list.marked": "Marqué comme favori",
  "favorites.list.remove": "Retirer des favoris",
  "favorites.confirmRemove": "Retirer ce favori ?",
  "favorites.confirmRemoveConfirm": "Retirer",
  "favorites.confirmRemoveCancel": "Annuler",
  "favorites.segment.all": "Tous",
  "favorites.segment.wineries": "Maisons de champagne",
  "favorites.segment.wineriesShort": "Maisons",
  "favorites.segment.landmarks": "Lieux",
  "favorites.tabs.all": "Tous",
  "favorites.tabs.landmarks": "Lieux",
  "favorites.errors.refresh": "Impossible d'actualiser les favoris.",
  "profile.title": "Profil",
  "profile.logout": "Se déconnecter",
  "profile.favorites.button": "Voir les favoris",
  "profile.login.title": "Connexion",
  "profile.login.labels.email": "E-mail",
  "profile.login.labels.password": "Mot de passe",
  "profile.login.placeholders.email": "vous@exemple.com",
  "profile.login.placeholders.password": "Entrez votre mot de passe",
  "profile.login.validation.email": "Indiquez une adresse e-mail valide.",
  "profile.login.validation.password": "Mot de passe requis.",
  "profile.login.submit": "Se connecter",
  "profile.login.switch": "Pas encore de compte ? Inscrivez-vous",
  "profile.login.error": "Impossible de vous connecter. Vérifiez vos identifiants.",
  "profile.register.title": "Inscription",
  "profile.register.labels.name": "Nom d'utilisateur",
  "profile.register.labels.email": "E-mail",
  "profile.register.labels.password": "Mot de passe",
  "profile.register.labels.confirmPassword": "Confirmer le mot de passe",
  "profile.register.placeholders.name": "Votre nom d'utilisateur",
  "profile.register.placeholders.email": "vous@exemple.com",
  "profile.register.placeholders.password": "Créez un mot de passe",
  "profile.register.placeholders.confirmPassword": "Ressaisissez le mot de passe",
  "profile.register.validation.name": "Veuillez indiquer votre nom d'utilisateur (2 caractères min., sans espaces).",
  "profile.register.validation.email": "Indiquez une adresse e-mail valide.",
  "profile.register.validation.password": "Le mot de passe doit contenir au moins 8 caractères.",
  "profile.register.validation.confirmPassword": "Les mots de passe doivent correspondre.",
  "profile.register.submit": "Créer un compte",
  "profile.register.switch": "Vous avez déjà un compte ? Connectez-vous",
  "profile.register.error": "Impossible de créer un compte pour le moment.",
  "profile.register.error.usernameTaken": "Ce nom d'utilisateur est déjà pris.",
  "profile.register.error.emailTaken": "Un compte existe déjà avec cet e-mail.",
  "profile.account.settings.title": "Compte",
  "profile.account.settings.description": "Gérez vos informations de profil et votre confidentialité.",
  "profile.account.settings.username": "Nom d'utilisateur",
  "profile.account.settings.usernameDescription": "Mettez à jour votre nom d'utilisateur.",
  "profile.account.settings.avatar": "Photo de profil",
  "profile.account.settings.avatarDescription": "Ajoutez ou changez la photo affichée sur votre profil.",
  "profile.account.settings.email": "Adresse e-mail",
  "profile.account.settings.emailDescription": "Modifiez votre e-mail de connexion et la vérification.",
  "profile.account.settings.password": "Mot de passe",
  "profile.account.settings.passwordDescription": "Modifiez le mot de passe utilisé pour vous connecter.",
  "profile.account.settings.dangerZone": "Zone dangereuse",
  "profile.account.settings.deletionDescription": "Demandez la suppression définitive de votre compte.",
  "profile.account.avatar.headline": "Définissez votre photo de profil",
  "profile.account.avatar.description": "Téléchargez une photo pour personnaliser votre compte.",
  "profile.account.avatar.hint": "Utilisez une image carrée et nette (max. 8 Mo).",
  "profile.account.avatar.select": "Choisir une image",
  "profile.account.avatar.remove": "Supprimer la photo de profil",
  "profile.account.avatar.noFile": "Choisissez une image avant de continuer.",
  "profile.account.avatar.invalidType": "Merci de sélectionner un fichier image.",
  "profile.account.avatar.fileTooLarge": "L'image est trop lourde (max. 8 Mo).",
  "profile.account.avatar.uploadFailed": "Échec du téléversement de l'image. Essayez un autre fichier.",
  "profile.account.avatar.success": "Photo de profil mise à jour.",
  "profile.account.avatar.removed": "Photo de profil supprimée.",
  "profile.account.avatar.error": "Impossible de mettre à jour la photo de profil pour le moment.",
  "profile.account.labels.name": "Nom d'utilisateur",
  "profile.account.labels.email": "E-mail",
  "profile.account.placeholders.name": "Votre nom d'utilisateur",
  "profile.account.placeholders.email": "vous@exemple.com",
  "profile.account.validation.name": "Veuillez indiquer votre nom d'utilisateur (2 caractères min., sans espaces).",
  "profile.account.validation.email": "Indiquez une adresse e-mail valide.",
  "profile.account.submit": "Enregistrer",
  "profile.account.success": "Compte mis à jour.",
  "profile.account.error": "Impossible de mettre à jour le compte pour le moment.",
  "profile.accountDeletion.cardTitle": "Supprimer mon compte",
  "profile.accountDeletion.description": "Demandez la suppression de votre compte et de vos données. Vous confirmerez avec votre mot de passe et un code email à 6 chiffres.",
  "profile.accountDeletion.passwordPlaceholder": "Mot de passe actuel",
  "profile.accountDeletion.passwordRequired": "Veuillez saisir votre mot de passe pour confirmer.",
  "profile.accountDeletion.requestCodeButton": "Envoyer le code",
  "profile.accountDeletion.codeTitle": "Saisir le code de confirmation",
  "profile.accountDeletion.codePlaceholder": "123456",
  "profile.accountDeletion.codeRequired": "Saisissez le code à 6 chiffres reçu par email.",
  "profile.accountDeletion.codeSent": "Un code de confirmation a été envoyé à votre email.",
  "profile.accountDeletion.codeError": "Impossible d'envoyer le code de confirmation pour le moment.",
  "profile.accountDeletion.confirmButton": "Supprimer le compte",
  "profile.accountDeletion.cancel": "Conserver mon compte",
  "profile.accountDeletion.success": "Votre compte a été supprimé. Nous sommes désolés de vous voir partir.",
  "profile.accountDeletion.error": "Impossible de supprimer votre compte pour le moment.",
  "profile.password.labels.current": "Mot de passe actuel",
  "profile.password.labels.new": "Nouveau mot de passe",
  "profile.password.labels.confirm": "Confirmer le nouveau mot de passe",
  "profile.password.placeholders.current": "Entrez le mot de passe actuel",
  "profile.password.placeholders.new": "Entrez le nouveau mot de passe",
  "profile.password.placeholders.confirm": "Ressaisissez le nouveau mot de passe",
  "profile.password.validation.current": "Veuillez saisir votre mot de passe actuel.",
  "profile.password.validation.length": "Le mot de passe doit contenir au moins 8 caractères.",
  "profile.password.validation.confirm": "Veuillez confirmer votre nouveau mot de passe.",
  "profile.password.error.mismatch": "Les nouveaux mots de passe ne correspondent pas.",
  "profile.password.error.generic": "Impossible de mettre à jour le mot de passe.",
  "profile.password.success": "Mot de passe mis à jour.",
  "profile.password.submit": "Mettre à jour",
  "profile.usernameAvailability.checking": "Vérification de la disponibilité...",
  "profile.usernameAvailability.available": "Nom d'utilisateur disponible.",
  "profile.usernameAvailability.unavailable": "Nom d'utilisateur indisponible.",
  "profile.usernameAvailability.error": "Impossible de vérifier la disponibilité pour le moment.",
  "landmarks.categories.museum": "Musée",
  "landmarks.categories.historical": "Site historique",
  "landmarks.categories.viewpoint": "Point de vue",
  "landmarks.categories.attraction": "Attraction"
}
